export enum LabelEntityType {
	PART = 'PART',
}

export type Label = {
	id: number;
	label: string;
	color: string;
	associatedPartsCount?: number;
};

export type LabelOption = {
	label: string;
	value: string;
};

export type CreateLabelRequest = {
	label: string;
	color: string;
};

export type UpdateLabelRequest = {
	label?: string;
	color?: string;
};
